<template>
  <div v-if="getDisconnectedPrinters.length > 0">
    <div class="tog tog--printer top-bar test" v-bind:style="{backgroundColor: '#767676'}">
      <div class="top-bar--left" @click="toggleAccordion">
        <i class="icon icon--play"></i>
        <h3>{{$t('printers.disconnected.waitingConnection')}}</h3>
      </div>
    </div>
    <b-collapse id="disconnectedPrinters" class="table table--disconnected table--files" v-model="showPrinters">
      <div v-for="(disconnectedPrinter, index) in getDisconnectedPrinters" :key="index">
        <DisconnectedPrinterItem :disconnected-printer="disconnectedPrinter"></DisconnectedPrinterItem>
        <hr v-if="index < count - 1" />
      </div>
    </b-collapse>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  import DisconnectedPrinterItem from "./DisconnectedPrinterItem";

  export default {
    name: 'disconnected-printers-list',
    components: {DisconnectedPrinterItem},
    data() {
      return {
        showPrinters: true
      }
    },
    computed: {
      ...mapGetters(['getDisconnectedPrinters']),

      count() {
        return this.getDisconnectedPrinters.length;
      }
    },
    methods: {
      toggleAccordion() {
        this.showPrinters = !this.showPrinters;
      }
    }
  }
</script>
